module.exports = __webpack_public_path__ + "img/1.496e6e7e.jpg";